// Description: First Step of the campaign add page
// Updated: 29/09/2025
// Author: Simon Franklin

// React
import React from 'react'

// Material UI Components
import { Box, Button, FormControl, TextField, Typography } from '@mui/material'

// Components and Functions for the project
import themeColors from '../../../components/ThemeColors/ThemeColors';

// Render The Component
const Step1 = ({ formState, updateFieldValue, error, setError, edit = false }) => {

    const categoryOptions = [
        { title: "Atrasos", id: "Atrasos" },
        { title: "Avisos", id: "Avisos" },
        { title: "Faturas", id: "Faturas" },
        { title: "Inadimplências", id: "Inadimplências" },
        { title: "Marketing", id: "Marketing" },
        { title: "Outros", id: "Outros" },
    ];

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
            <Box sx={{ display: "flex", gap: "30px" }}>
                <FormControl sx={{ width: "400px", display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Título da Campanha"] === true ? "red" : "#000", fontSize: "14px" }}>
                        Título da Campanha
                    </div>
                    <TextField
                        name={"Título da Campanha"}
                        variant="outlined"
                        placeholder={"Título da Campanha"}
                        value={formState["Título da Campanha"] === false ? "" : formState["Título da Campanha"]}
                        onChange={(e) => {
                            updateFieldValue("Título da Campanha", e.target.value);
                            if (error["Título da Campanha"] === true) {
                                setError((prev) => ({
                                    ...prev,
                                    "Título da Campanha": false
                                }));
                            }
                        }}
                        fullWidth
                        rows={1}
                        sx={{ '& .css-1d0qoyg-MuiInputBase-root-MuiOutlinedInput-root': { backgroundColor: error["Título da Campanha"] === true ? themeColors.red01 : '#FFF' }, borderRadius: '6px', '.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': { padding: '13px' }, maxWidth: "387px" }}
                    />
                </FormControl>

                {edit === true && (
                    <FormControl sx={{ width: "400px", display: "flex", flexDirection: "column", gap: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: "#000", fontSize: "14px" }}>
                            Status da Campanha
                        </div>
                        <Box sx={{ display: 'flex', gap: '6px', flexDirection: 'column', width: '100%' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px', backgroundColor: formState["Status da Campanha"] === 'Active' || formState["Status da Campanha"] === 'active' ? themeColors.green01 : themeColors.red01, width: '100%', borderRadius: '6px' }}>
                                <Typography sx={{ color: formState["Status da Campanha"] === 'Active' || formState["Status da Campanha"] === 'active' ? themeColors.green03 : themeColors.red03, fontSize: '16px', fontWeight: 500 }}>{formState["Status da Campanha"] === 'Active' || formState["Status da Campanha"] === 'active' ? 'Ativa' : 'Desativada'}</Typography>
                            </Box>
                        </Box>
                    </FormControl>
                )}
            </Box>

            <FormControl sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Descrição da Campanha"] === true ? "red" : "#000", fontSize: "14px" }}>
                    Descrição da Campanha
                </div>
                <TextField
                    name={"Descrição da Campanha"}
                    variant="outlined"
                    placeholder={"Descrição da Campanha"}
                    value={formState["Descrição da Campanha"] === false ? "" : formState["Descrição da Campanha"]}
                    onChange={(e) => {
                        updateFieldValue("Descrição da Campanha", e.target.value);
                        if (error["Descrição da Campanha"] === true) {
                            setError((prev) => ({
                                ...prev,
                                "Descrição da Campanha": false
                            }));
                        }
                    }}
                    rows={4}
                    multiline
                    fullWidth
                    sx={{ '& .css-17m5yr0-MuiInputBase-root-MuiOutlinedInput-root': { backgroundColor: error["Descrição da Campanha"] === true ? themeColors.red01 : '#FFF', height: '100% !important' }, borderRadius: '6px', '.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': { padding: '13px' }, maxWidth: "387px" }}
                />
            </FormControl>

            <FormControl sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", color: error["Categoria"] === true ? "red" : "#000", fontSize: "14px" }}>
                    Categoria
                </div>

                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        maxWidth: '100%',
                        gap: '13.72px',
                        height: '29px',
                        overflowX: 'auto'
                    }}
                >
                    {categoryOptions.map((type, index) => (
                        <Button
                            key={type}
                            onClick={() => {
                                updateFieldValue("Categoria", type.title)
                                if (error["Categoria"] === true) {
                                    setError((prev) => ({
                                        ...prev,
                                        "Categoria": false
                                    }));
                                }
                            }}
                            sx={{
                                mx: index === 0 || index === categoryOptions.length - 1 ? 0 : 0.5,
                                bgcolor:
                                    formState["Categoria"] === type.title ? '#8142FC' : error["Categoria"] === true ? themeColors.red01 : themeColors.gray30,
                                color: error["Categoria"] === true ? themeColors.red03 : '#fff',
                                borderRadius: '27px',
                                '&:hover': {
                                    bgcolor: formState["Categoria"] === type.title ? '#8142FC' : 'gray',
                                },
                                fontSize: '12px',
                                padding: { xs: '4px 10px', sm: '4px 16px' },
                                height: '29px'
                            }}
                        >
                            {type.title}
                        </Button>
                    ))}
                </Box>
            </FormControl>
        </div>
    )
}

export default Step1